import React from 'react';
import { Image, Camera, Calculator } from 'lucide-react';

const VisualizationSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  visualizationTypes 
}) => {
  if (!formData.includeVisualization) return null;

  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calculator className="w-5 h-5 mr-2 text-purple-500" />
        Визуализация проекта
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип визуализации */}
        <div>
          <label htmlFor="visualizationType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип визуализации
          </label>
          <select
            id="visualizationType"
            name="visualizationType"
            value={formData.visualizationType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.visualizationType ? 'input-error' : ''}`}
          >
            <option value="">Выберите тип визуализации</option>
            {visualizationTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name} ({type.costPerUnit.toLocaleString()} ₽ за единицу)
              </option>
            ))}
          </select>
          {errors.visualizationType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.visualizationType}
            </p>
          )}
        </div>

        {/* Количество визуализаций */}
        <div>
          <label htmlFor="numVisualizations" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество визуализаций
          </label>
          <input
            type="text"
            id="numVisualizations"
            name="numVisualizations"
            value={formData.numVisualizations}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.numVisualizations ? 'input-error' : ''}`}
            placeholder="Введите количество"
          />
          {errors.numVisualizations && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.numVisualizations}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg border border-purple-200 dark:border-purple-800">
        <div className="flex items-start">
          <Camera className="w-5 h-5 text-purple-600 dark:text-purple-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">
              О типах визуализации
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400">
              3D рендеры - фотореалистичная визуализация проекта, показывающая внешний вид и интерьеры здания.
              3D анимация - видеоролик с облетом здания или проходом по интерьеру.
              VR прогулка - интерактивная 3D-модель для просмотра в VR-устройствах.
              Скетчи от руки - художественные эскизы проекта, выполненные архитектором.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisualizationSection;